export default __webpack_public_path__ + "static/media/farm_dark.5462181e.png";